/*
 * Copyright (c) 2025 AirAsia Berhad (Malaysia). All rights reserved.
 *
 * This software is proprietary and confidential. Unauthorized copying of this file,
 * via any medium, is strictly prohibited. Do not distribute, copy, modify, or reuse
 * any part of this code without explicit written permission from AirAsia Move.
 *
 * For internal use only.
 */

//ReactNativeErrorBoundary imports
import { LabelsType } from './labels.types';

const Labels: LabelsType = {
  'en-gb': {
    PRIMARY_TEXT: 'Something went wrong',
    SECONDARY_TEXT:
      'We’re sorry. Something failed while loading the next page. Please retry to continue',
    BUTTON_RETRY_TEXT: 'Retry',
    BUTTON_GO_BACK_TEXT: 'Go Back',
  },
};

export default Labels;
